import { useFlag } from '@calendly/feature-check-react'
import { useFormContext } from '@calendly/form'
import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'
import { useSelector } from 'react-redux'

import { isAdminOrOwnerSelector, isGroupAdminSelector } from 'selectors/current_user'


import { EmptyLogoBox, LogoBox, NonEnforcedLogoBox } from './logo_box'
import { isProfileLogoSelector } from '../../../selectors'


export const Restricted = () => {
  const isGroupBrandingFeatureEnabled = useFlag('org_enablement_group_branding_feature')
  const { values: { logo: previewUrl } } = useFormContext()
  const isOwnerOrAdmin = useSelector(isAdminOrOwnerSelector)
  const isGroupAdmin = useSelector(isGroupAdminSelector)
  const isProfileLogo = useSelector(isProfileLogoSelector)

  if (isGroupBrandingFeatureEnabled) {
    const isOwnerOrAdminOrGroupAdmin = isOwnerOrAdmin || isGroupAdmin

    return (
      <>
        {previewUrl && <LogoBox src={previewUrl} />}
        {!previewUrl && isProfileLogo && <EmptyLogoBox />}
        {!previewUrl && !isProfileLogo && <NonEnforcedLogoBox />}
        <BodyText color="muted">
          {isOwnerOrAdminOrGroupAdmin
            ? HtmlParser(I18n.t('publisher.account_settings.branding.logo_managed_by_organization_with_link'))
            : I18n.t('publisher.account_settings.branding.logo_managed_by_organization')}
        </BodyText>
      </>
    )
  }

  return (
    <>
      {previewUrl ? <LogoBox src={previewUrl} /> : <EmptyLogoBox />}
      <BodyText color="muted">
        {I18n.t('publisher.account_settings.branding.enforced_message')}
      </BodyText>
    </>
  )
}
